import { render } from "./eatXfbmupdown.vue?vue&type=template&id=50dcf0b7"
import script from "./eatXfbmupdown.vue?vue&type=script&lang=js"
export * from "./eatXfbmupdown.vue?vue&type=script&lang=js"

import "./eatXfbmupdown.vue?vue&type=style&index=0&id=50dcf0b7&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__